import {useTranslations} from 'next-intl';
import {Row, Col} from '@/grid';
import Container from '@/container';
import {P} from '@/typography';
import {withPurple800} from '@/hocs/withColors';
import {withFlexHolder} from '@/hocs/withFlex';
import {BreakVisibleInDesktop} from '@/breaks';
import {Grid} from '@/content/workable-ai/shared';
import styles from './forbes-banner.module.scss';

const FlexHolderRow = withFlexHolder(Row);
const BannerTextPurple800 = withPurple800(P);

const ForbesBanner = () => {
  const t = useTranslations('workableAi.forbesBanner');

  return (
    <Container>
      <Grid fluid>
        <FlexHolderRow center="xs">
          <Col xs={12} lg={10} xl={8}>
            <div className={styles['forbes-banner']}>
              <Row middle="lg">
                <Col xs={12} lg={4}>
                  <picture>
                    <img
                      srcSet="/static/images/workable-ai/rating.png 1x, /static/images/workable-ai/rating_2x.png 2x"
                      src="/static/images/workable-ai/rating_2x.png"
                      loading="lazy"
                      alt={t('ratingAlt')}
                    />
                  </picture>
                </Col>
                <Col xs={12} lg={8}>
                  <BannerTextPurple800>
                    {t.rich('text', {
                      br: () => <BreakVisibleInDesktop />
                    })}
                  </BannerTextPurple800>
                </Col>
              </Row>
            </div>
          </Col>
        </FlexHolderRow>
      </Grid>
    </Container>
  );
};

export default ForbesBanner;
